import { render, staticRenderFns } from "./CheckboxSwitch.vue?vue&type=template&id=6148c087&scoped=true&"
import script from "./CheckboxSwitch.vue?vue&type=script&lang=js&"
export * from "./CheckboxSwitch.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxSwitch.vue?vue&type=style&index=0&id=6148c087&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6148c087",
  null
  
)

export default component.exports